import * as types from "./types";
import JigsawAPI from "../../services/jigsaw";
import * as selectors from "./selectors";
import { getBrandValue } from "../brand/selectors";

export const getBookListBegin = () => ({
  type: types.GET_BOOK_LIST_REQUEST,
  updating: true
});

export const getBookListFinish = state => {
  const isbns = selectors.getIsbns(state);
  return {
    type: types.GET_BOOK_LIST_SUCCESS,
    updating: false,
    total: isbns ? isbns.length : 0
  };
};

export const getBookListIntermediateResponse = response => {
  const isAsset = book => !(book.ssoOnly && book.kind === "online resource");
  const nonBooks = response.books.filter(book => !isAsset(book));
  return {
    type: types.GET_BOOK_LIST_INTERMEDIATE_RESPONSE,
    response: {
      ...response,
      total: response.total - nonBooks.length,
      books: response.books.filter(isAsset)
    }
  };
};

export const getExpiredBooksRequest = () => ({
  type: types.GET_EXPIRED_BOOKS_REQUEST,
  updating: true
});

const getExpiredBooksSucess = books => ({
  type: types.GET_EXPIRED_BOOKS_SUCCESS,
  updating: false,
  expiredBooks: books
});

const getExpiredBooksFailure = () => ({
  type: types.GET_EXPIRED_BOOKS_FAILURE,
  updating: false,
  expiredBooks: {}
});

export const getBookInfoRequest = (isbns = []) => ({
  type: types.GET_BOOK_INFO_REQUEST,
  isbns
});

export const getBookInfoSuccess = (books = []) => ({
  type: types.GET_BOOK_INFO_SUCCESS,
  books
});

const shouldLoadBookList = state =>
  !(selectors.isLoading(state) || selectors.finishedLoading(state));

const shouldFetchExpired = state => {
  return selectors.getExpiredLoadStatus(state) === "waiting";
};

export const loadBookList = (options, force = false) => async (
  dispatch,
  getState
) => {
  const state = getState();
  if (force || shouldLoadBookList(state)) {
    dispatch(getBookListBegin());
    let options = {
      order: "recent",
      offset: 0,
      perPage: 25,
      eager: true
    };
    let response = await JigsawAPI.getBookList(options);
    while (response.books.length > 0) {
      dispatch(getBookListIntermediateResponse(response));
      options.offset = options.offset + response.books.length;
      options.perPage = 1000;
      response = await JigsawAPI.getBookList(options);
    }
    dispatch(getBookListFinish(getState()));
  }
};

export const loadExpiredBooks = () => async (dispatch, getState) => {
  if (shouldFetchExpired(getState())) {
    try {
      dispatch(getExpiredBooksRequest());
      const response = await JigsawAPI.getExpiredBooks();
      dispatch(getExpiredBooksSucess(response));
    } catch (e) {
      dispatch(getExpiredBooksFailure());
    }
  }
};

export const getBookInfo = isbns => async (dispatch, getState) => {
  const loaded = selectors.getNormalizedBooks(getState());

  const stats = isbns.reduce(
    (acc, i) => {
      return loaded[i] && loaded[i].title
        ? { ...acc, loaded: [...acc.loaded, loaded[i]] }
        : { ...acc, needed: [...acc.needed, i] };
    },
    { loaded: [], needed: [] }
  );

  dispatch(getBookInfoRequest(stats.needed));

  const newlyLoaded =
    stats.needed.length > 0 ? await JigsawAPI.getBookInfo(stats.needed) : [];

  return dispatch(getBookInfoSuccess(newlyLoaded.books));
};
